<template>
    <nav>
        <AlertMessages
            v-if="alertValue"
            :alert-type="alertType" 
            :alert-msg="alertMsg"
            @reset="alertValue = false"
        />
        <v-row
            v-if="!loadingData && storeOrder.attributes"
            align="center"
            class="mx-auto"
        >
            <v-col
                cols="11"
                class="mx-auto px-0"
            >
                <v-row>
                    <v-col cols="12" md="6" sm="12">
                        <p class="text-body-1">
                            <span class="mr-2">{{$t('orderOverviewTitle')}}</span>
                            <span v-if="storeOrderStatus == true"><v-chip  color="success" data-testid="chip-order-approved" class="rounded-xxl text-none px-4 white--text mr-2">{{ $t('approved') }}</v-chip>
                                <v-tooltip bottom v-if="storeOrder.attributes.approved && storeOrder.meta.approval_method == null">
                                    <template v-slot:activator="{ on }">
                                        <v-icon
                                        v-on="on" 
                                        class="pa-0 darktext--text"  
                                        data-testid="icon-file" 
                                        v-if="storeOrder.attributes.approved" 
                                        @click.stop="openOrderDocument()" 
                                        > 
                                        mdi-file-document-outline 
                                        </v-icon>
                                    </template>
                                    <span>{{ $t('downloadOrderInvoiceTooltip') }}</span>
                                </v-tooltip>
                            </span>
                            <v-chip v-else-if="storeOrderStatus == false" color="error" data-testid="chip-order-denied" class="rounded-xxl text-none px-4 white--text mr-2">{{ $t('denied') }}</v-chip>
                            <v-chip v-else color="warning" data-testid="chip-order-pending" class="rounded-xxl text-none px-4 white--text mr-2">{{ $t('pending') }}</v-chip>
                        </p>
                        <v-card rounded="xxl" class="elevation-2 pa-5" data-testid="order-overview-card">
                            <p class="text-h6" data-testid="order-product-title">{{ storeOrder.attributes.product.title }} {{ (storeOrder.attributes.session) ? ' - ' + storeOrder.attributes.session.session_title : '' }}</p>
                            <div class="my-4">
                                <span class="text-body-2 grey--text">{{ $t('orderOrderedBy')}}</span>
                                <v-row no-gutters>
                                    <v-col cols="12" md="6" class="pr-2">
                                        <span class="text-body-1" data-testid="order-customer-name">{{ storeOrder.attributes.first_name }} {{ storeOrder.attributes.last_name }}</span>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <span class="text-body-1" data-testid="order-customer-email">{{ storeOrder.attributes.email }}</span>
                                    </v-col>
                                </v-row>
                            </div>
                            <v-divider></v-divider>
                            <div class="my-4">
                                <span class="text-body-2 grey--text">{{ $t('orderNumberOfParticipants')}}</span>
                                <v-row no-gutters>
                                    <v-col cols="12" md="6">
                                        <span class="text-body-1" data-testid="order-number-of-participants">{{ storeOrder.attributes.participants.length }}</span>
                                    </v-col>
                                </v-row>
                            </div>
                            <v-divider></v-divider>
                            <div class="my-4">
                                <v-row no-gutters>
                                    <v-col cols="12" md="6" class="pr-2">
                                            <span class="text-body-2 grey--text d-flex">{{ $t('orderInvoiceReference')}}</span>
                                        <span class="text-body-1" data-testid="order-company-name">{{ storeOrder.attributes.company_name }}</span>
                                    </v-col>
                                    <v-col cols="12" md="6" class="">
                                        <span class="text-body-2 grey--text d-flex">{{ $t('labelOrderNumber')}}</span>
                                        <span class="text-body-1" data-testid="order-number">{{ storeOrder.attributes.number }}</span>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="12">
                                        <span class="text-body-1" data-testid="order-company-address">{{ storeOrder.attributes.company_address }} {{ storeOrder.attributes.city }} {{ storeOrder.attributes.post_code }}</span>
                                    </v-col>
                                    <template v-if="storeOrder.attributes.company_custom_attributes">
                                        <v-col cols="12" :key="key" data-testid="order-company-fields" v-for="(value, key) in storeOrder.attributes.company_custom_attributes">
                                            <span class="text-body-1" ><strong>{{ key }}:</strong> {{ value }} </span>
                                        </v-col>
                                    </template>
                                   
                                </v-row>
                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="6" sm="12">
                        <div data-testid="pulbic-page-url" v-if="storeOrderStatus == true">
                            <p class="mt-1 mb-5">{{ $t("storeOrderPublicStatisticPageTitle") }}</p>
                            <v-card rounded="xxl" class="elevation-2 pa-5 mb-6">
                                <v-row no-gutters class="mb-1" data-testid="order-participant">
                                    <v-col cols="12">
                                        <p class="text-body-1 mb-0 mt-1">
                                            {{ $t("labelURL") }}: {{ storeOrderPublicUrl }}
                                            <v-icon
                                                class="ml-2"
                                                data-testid="copy-icon"
                                                dense
                                                color="darktext"
                                                @click="copy(storeOrderPublicUrl)"
                                                >
                                                mdi-content-copy
                                            </v-icon>
                                        </p>
                                    </v-col>
                                    <v-col cols="12">
                                        <p class="text-body-1 mb-0 mt-1">
                                            {{ $t("storeOrderAccessCode") }}: {{ accessCode }}
                                            <v-icon
                                                class="ml-2"
                                                data-testid="copy-icon"
                                                dense
                                                color="darktext"
                                                @click="copy(accessCode)"
                                                >
                                                mdi-content-copy
                                            </v-icon>
                                        </p>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </div>
                        <div data-testid="participants">
                            <p class="mt-1 mb-5">{{ $t("orderParticipantsTitle") }}</p>
                            <v-card rounded="xxl" class="elevation-2 pa-5" v-if="(storeOrderStatus == true) && (storeOrder.attributes.product.productable_type == 'App\\Models\\Hub')">
                                <v-row v-for="participant in storeOrder.attributes.participants" :key="participant.id" no-gutters class="mb-1" data-testid="order-participant">
                                    <v-col cols="12" md="4" class="pr-2">
                                        <p class="text-body-1 mb-0 mt-1">{{ participant.first_name }} {{ participant.last_name }}</p>
                                    </v-col>
                                    <v-col cols="12" md="5">
                                        <p class="text-body-1 grey--text mb-0 mt-1">{{ participant.email }}</p>
                                    </v-col>
                                    <v-col cols="12" md="3"  class="text-right d-md-flex align-md-center justify-md-end pr-lg-5" data-testid="hub-status-participant">
                                        <v-chip class="chip" color="accent" text-color="white">
                                        {{ $t('hub') }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                            </v-card>
                            <v-card rounded="xxl" class="elevation-2 pa-5" v-else-if="storeOrderStatus == true">
                                <v-row v-for="participant in storeOrder.attributes.participants" :key="participant.id" no-gutters class="mb-1" data-testid="order-participant">
                                    <v-col cols="12" md="4" class="pr-2">
                                        <p class="text-body-1 mb-0 mt-1" :style="{'cursor': 'pointer'}" @click="openParticipant(participant)">{{ participant.first_name }} {{ participant.last_name }}</p>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <p class="text-body-1 grey--text mb-0 mt-1">{{ participant.email }}</p>
                                    </v-col>
                                    <v-col cols="12" md="4"  class="text-right d-md-flex align-md-center justify-md-end pr-lg-5" data-testid="status-participant">
                                        <v-chip class="chip" :color="getStatusColor(participant.user_id)" text-color="white">
                                        {{ getStatus(participant.user_id) }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                            </v-card>
                            <v-card rounded="xxl" class="elevation-2 pa-5" v-else>
                                <v-row v-for="participant in storeOrder.attributes.participants" :key="participant.id" no-gutters class="mb-1" data-testid="participant-without-status">
                                    <v-col cols="12" md="6" class="pr-2">
                                        <p class="text-body-1 mb-0 mt-1" :style="{'cursor': 'pointer'}" @click="openParticipant(participant)">{{ participant.first_name }} {{ participant.last_name }}</p>
                                    </v-col>
                                    <v-col cols="12" md="6" class="text-right  pr-5">
                                        <p class="text-body-1 grey--text mb-0 mt-1">{{ participant.email }}</p>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </div>
                    </v-col>  
                </v-row>
                <div class="text-right mt-5" v-if="storeOrderStatus == null">
                    <v-btn 
                        v-if="storeOrder.attributes.approved == null"
                        data-testid="approve-button"
                        color="success"
                        class="rounded-xxl text-none px-4 white--text mr-2"
                        @click.stop="
                            approved= true,
                            dialogVisibleApproveDenyOrder=true,
                            confirmationDialogTitle=$t('confirmationDialogTitleApproveOrder'),
                            confirmationDialogText=$t('confirmationDialogTextApproveOrder'),
                            confirmationDialogSubmitBtnColor='success',
                            confirmationDialogSubmitBtn=$t('approve')
                            confirmationDialogCancelBtn=$t('cancel')
                        "
                    >
                        {{ $t('approve') }}
                    </v-btn>
                    <v-btn 
                        v-if="storeOrder.attributes.approved == null"
                        data-testid="deny-button"
                        color="error"
                        class="rounded-xxl text-none px-4 white--text mr-2"
                        @click.stop="
                            approved= false,
                            dialogVisibleApproveDenyOrder=true,
                            confirmationDialogTitle=$t('confirmationDialogTitleDenyOrder'),
                            confirmationDialogText=$t('confirmationDialogTextDenyOrder'),
                            confirmationDialogSubmitBtnColor='error',
                            confirmationDialogSubmitBtn=$t('deny')
                            confirmationDialogCancelBtn=$t('cancel')
                        "
                    >
                        {{ $t('deny') }}
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <ConfirmationDialog
            v-if="dialogVisibleApproveDenyOrder"
            ref="confirmationDialogApproveDenyOrder"
            :visible="dialogVisibleApproveDenyOrder"
            :cd-title="confirmationDialogTitle"
            :cd-text="confirmationDialogText"
            :cd-submit-btn="confirmationDialogSubmitBtn"
            :cd-cancel-btn="confirmationDialogCancelBtn"
            :cd-submit-btn-color="confirmationDialogSubmitBtnColor"
            data-testid="confirmation-dialog-order" 
            @close="dialogVisibleApproveDenyOrder=false"
            @proceedSubmit="approveDenyStoreOrder()"
        /> 
        <ConfirmationDialogApproveOrder
            v-if="dialogVisibleApproveDenyOrder && (integrationId || vismaIntegrationId) && price > 0"
            ref="confirmationDialogApproveDenyOrder"
            :visible="dialogVisibleApproveDenyOrder"
            :integrationIds="{'fortnox' : integrationId, 'visma' : vismaIntegrationId}"
            :orderId="storeID"
            :cd-title="confirmationDialogTitle"
            :cd-text="confirmationDialogText"
            :cd-submit-btn="confirmationDialogSubmitBtn"
            :cd-cancel-btn="confirmationDialogCancelBtn"
            :cd-submit-btn-color="confirmationDialogSubmitBtnColor"
            data-testid="confirmation-dialog-order" 
            @close="dialogVisibleApproveDenyOrder=false"
            @proceedSubmit="approveDenyStoreOrder($event)"
        />  
        <ParticipantDetails
            v-if="showParticipant"
            ref="showParticipantDialog"
            :visible="showParticipant"
            :participant="selectedParticipant"
            :custom_attributes="storeOrder.attributes.product.participant_custom_attributes"
            :participant_attributes="processedParticipantAttributes"
            data-testid="view-dialog-participant" 
            @close="showParticipant=false"
        /> 

    </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { getVismaIntegration } from '../../api/vismaApi'
import AlertMessages  from '../../components/AlertMessages'
import { getFortnoxIntegration } from '../../api/fortnoxApi'
import ConfirmationDialog from '../../components/ConfirmationDialog'
import ParticipantDetails from '../../components/ParticipantDetails'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import ConfirmationDialogApproveOrder from '../../components/ConfirmationDialogApproveOrder'
import { getStoreOrder, approveDenyOrder,getStoreOrderUsersStatistics,downloadInvoiceOrderData } from '../../api/productApi'

export default {
    components: {
        AlertMessages,
        ConfirmationDialog,
        ConfirmationDialogApproveOrder,
        ParticipantDetails
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            alertType: '',
            alertMsg: '',
            alertValue:false,
            spaceId: window.$cookies.get('space_id'),
            loadingData: false,
            hasFortnoxIntegration: false,
            hasVismaIntegration: false,
            vismaIntegrationId: "",
            integrationId: "",
            storeOrder: {},
            storeID: this.$route.params.id,
            space: window.location.host.split('.')[0],
            dialogVisibleApproveDenyOrder: false,
            approved: null,
            confirmationDialogTitle: '',
            confirmationDialogText: '',
            confirmationDialogCancelBtn: '',
            confirmationDialogSubmitBtn: '',
            confirmationDialogSubmitBtnColor: '',
            storeOrderStatus: null,
            storeOrderUsersStatistics:[],
            storeOrderPublicUrl: '',
            accessCode: '',
            customerNumber: '',
            price: 0,
            selectedParticipant: {},
            showParticipant: false
        }
    },

    async created(){      
         if(this.$route.params.successfullyAttachedCustomer){      
            this.alertType = 'success'    
            this.alertMsg = i18n.t('attachedCustomerSuccessMsg')
            this.alertValue = true
        }
        this.loadingData = true
        await this.fetchStoreOrder()
        
        this.loadingData = false
    },
    computed: {
        processedParticipantAttributes() {
            if (
                Array.isArray(this.storeOrder.attributes.product.additional_attributes_for_participants) && 
                this.storeOrder.attributes.product.additional_attributes_for_participants.length === 0) {
                return {};
            } else {
                return this.storeOrder.attributes.product.additional_attributes_for_participants;
            }
        }
    },
    methods:{
        openParticipant(participant) {
            this.showParticipant = true;
            this.selectedParticipant = participant;
        },
        async fetchStoreOrder() {
            try {
                const response = await getStoreOrder(this.storeID);
                if (response.status == 200) {
                    this.storeOrder = response.data.data
                    this.storeOrderStatus = response.data.data.attributes.approved
                    this.accessCode = response.data.data.attributes.access_code
                    this.price = response.data.data.attributes.total_price
                    this.storeOrderPublicUrl = window.location.origin +'/order/'+this.storeOrder.id
                    if(this.storeOrderStatus == true && this.storeOrder.attributes.product.productable_type != 'App\\Models\\Hub') {
                       await this.fetchStoreOrderUsersStatistics()
                    }
                    if(this.storeOrderStatus == null){
                        await this.checkFortnoxIntegration()
                        await this.checkVismaIntegration()
                    }
                }
            } catch (e) {
                if(e.response){
                    if(e.response.status == 404) {
                        this.$router.push({name: 'PageNotFound'})
                    }
                    else if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        async checkFortnoxIntegration() {
            try {
                const response = await getFortnoxIntegration(this.spaceId);
                if (response.status == 200) {
                    if(response.data.data.length > 0){
                        this.hasFortnoxIntegration = response.data.data[0].meta.status == 'valid' ? true : false;
                        if(this.hasFortnoxIntegration){
                            this.integrationId = response.data.data[0].id;
                        }
                    }
                }
            } catch (e) {
                if(e.response){
                    if(e.response.status == 404) {
                        this.$router.push({name: 'PageNotFound'})
                    }
                    else if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        async checkVismaIntegration() {
            try {
                const response = await getVismaIntegration(this.spaceId);
                if (response.status == 200) {
                    if(response.data.data.length > 0){
                        this.hasVismaIntegration = response.data.data[0].meta.status == 'valid' ? true : false;
                        if(this.hasVismaIntegration){
                            this.vismaIntegrationId = response.data.data[0].id;
                        }
                    }
                }
            } catch (e) {
                if(e.response){
                    if(e.response.status == 404) {
                        this.$router.push({name: 'PageNotFound'})
                    }
                    else if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },

        async fetchStoreOrderUsersStatistics() {
            try {
                const response = await getStoreOrderUsersStatistics(this.storeID);
                if (response.status == 200) {
                    this.storeOrderUsersStatistics = response.data.meta.statistics ? response.data.meta.statistics : [];
                }   
            } catch (e) {
                if(e.response){
                    if(e.response.status == 404) {
                        this.$router.push({name: 'PageNotFound'})
                    }
                    else if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        async approveDenyStoreOrder(event = null) {
            try {
                let data = {
                    data: {
                        type: "store-orders",
                        attributes: {
                            'approve': this.approved,
                        },
                    }
                };

                if (event !== null) {
                    data.data.attributes['customerNumber'] = event?.customerNumber;
                    if (event.method == 'sendViaVisma') {
                        data.data.attributes['method'] = 'visma';
                    } else if(event.method == 'sendViaFortnox') {
                        data.data.attributes['method'] = 'fortnox';
                    }
                    data.data.attributes['articleId'] =  event?.articleId;
                }
                var response = await approveDenyOrder(this.storeID, data);
                if(response.status == 200) {
                    this.storeOrderStatus = response.data.meta.approved
                    this.accessCode = response.data.meta.access_code
                    if(this.storeOrderStatus == true && this.storeOrder.attributes.product.productable_type != 'App\\Models\\Hub') {
                       await this.fetchStoreOrderUsersStatistics()
                    }
                    this.dialogVisibleApproveDenyOrder = false
                }
            } catch (e) {
                if(e.response){
                    if (e.response.status == 403){
                        for(let i = 0; i < e.response.data.errors.length; i++){
                            if(e.response.data.errors[i].detail == 'Member Limit is reached'){
                                this.dialogVisibleApproveDenyOrder = false
                                this.alertValue = true
                                this.alertType = 'error'
                                this.alertMsg =  i18n.t('approveOrderSpaceLimitReached')
                            }
                            else if(e.response.data.errors[i].detail == 'Participant Limit is reached'){
                                this.dialogVisibleApproveDenyOrder = false
                                this.alertValue = true
                                this.alertType = 'error'
                                this.alertMsg =  i18n.t('approveOrderProductLimitReached')
                            }
                            else {
                                this.$router.push({name: 'PageAccessDenied'})
                            }
                        }     
                    } else if(e.response.status == 400) {
                        for(let i = 0; i < e.response.data.errors.length; i++){
                            if(e.response.data.errors[i].detail == 'Store settings not added.'){
                                this.alertValue = true
                                this.alertType = 'error'
                                this.alertMsg = i18n.t('approveOrderSettingsNotAdded')
                            } else {
                                this.alertValue = true
                                this.alertType = 'error'
                                this.alertMsg = i18n.t('serverError')
                            }
                        }
                    }else {
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
            this.dialogVisibleApproveDenyOrder = false
        },
        getStatusColor(participantId) {
            if(this.storeOrderUsersStatistics.length == 0) return 'graylight';

            const participantStatus = this.storeOrderUsersStatistics.find(stat => stat.user_id === participantId);
            if (participantStatus) {
                if (!participantStatus.completed) {
                    return 'bluelight';//notstarted 
                } else if (participantStatus.completed == participantStatus.total) {
                    return 'green'; //  finished
                } else {
                    return 'warning';//started
                }
            }
            return 'graylight';
        },
        getStatus(participantId) {
             if(this.storeOrderUsersStatistics.length == 0) return 'N/A';

            const participantStatus = this.storeOrderUsersStatistics.find(stat => stat.user_id === participantId);
            if (participantStatus) {
                 if (!participantStatus.completed) {
                    return i18n.t('notStarted'); 
                } else if (participantStatus.completed == participantStatus.total) {
                    return i18n.t('finished');
                } else {
                    return i18n.t('started');
                }
            }
            return 'N/A';
        },
        async openOrderDocument() {
            try {
                const response = await downloadInvoiceOrderData(this.storeID);
                if (response.status) {
                    if (response.status == 200) {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'invoice-order.pdf');
                        document.body.appendChild(link);
                        link.click();
                    }
                }
            } catch (e) {
                if (e.response) {
                this.alertValue = true;
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
                }
            }
        },
        copy(text){
            const el = document.createElement('textarea');  
            el.value = text
            document.body.appendChild(el);                          
            el.select();                                    
            document.execCommand('copy');                   
            document.body.removeChild(el);
        },
    }
}
</script>  